import { SVGProps } from 'react'

export function TiktokIcon({ ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      {...props}
    >
      <path
        d="M11.9447 3.55262L11.9429 3.55061C11.5672 3.12147 11.36 2.57046 11.3601 2.00005L11.3602 1.5H10.8601H8.8001H8.3001V2V10.2572C8.28711 10.5722 8.15335 10.8702 7.92639 11.0893C7.69754 11.3102 7.39182 11.4335 7.07374 11.4333H7.07344C6.40041 11.4333 5.8401 10.8814 5.8401 10.2C5.8401 9.38108 6.62911 8.77331 7.43875 9.02425L8.08677 9.2251V8.54667V6.44V6.00224L7.65285 5.94439C5.05243 5.59766 2.77344 7.61829 2.77344 10.2C2.77344 12.7176 4.85923 14.5 7.06677 14.5C9.43682 14.5 11.3601 12.5756 11.3601 10.2V6.88452C12.0943 7.24093 12.9035 7.42808 13.7276 7.42667L14.2268 7.42581V6.92667V4.86667V4.34216L13.7062 4.3671L13.7055 4.36711L13.7054 4.36713L13.7027 4.36718C13.6982 4.36727 13.6894 4.36737 13.6767 4.36723C13.6513 4.36695 13.6106 4.36567 13.5574 4.36134C13.4506 4.35263 13.2965 4.33181 13.1178 4.2833C12.7606 4.18632 12.3171 3.98251 11.9447 3.55263L11.9447 3.55262Z"
        stroke="currentColor"
      />
    </svg>
  )
}
